import { render, staticRenderFns } from "./landing-hero-image-credit.vue?vue&type=template&id=6c94c06a&scoped=true&"
var script = {}
import style0 from "./landing-hero-image-credit.vue?vue&type=style&index=0&id=6c94c06a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94c06a",
  null
  
)

export default component.exports